import { render, staticRenderFns } from "./ClickHouse.vue?vue&type=template&id=f4a32766&scoped=true"
import script from "./ClickHouse.vue?vue&type=script&lang=js"
export * from "./ClickHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a32766",
  null
  
)

export default component.exports